<script>
import FormModal from "@/components/form-modal.vue";
import MasterDetail from "@/components/master-detail.vue";
import Modal from "@/components/g-modal.vue";
import moment from "moment";
import { isNil, partition } from "lodash";
import { mapGetters } from "vuex";
import { StatusBusinessPlanEnum } from "@/core/enums/ativacaoped";
import toMonth from "@/helpers/toMonth";

export const DespesaTipoEnum = Object.freeze({
  PROJETADO: 1,
  REALIZADO: 2
});

export default {
  components: {
    FormModal,
    MasterDetail,
    Modal
  },
  props: {
    editable: Boolean,
    endDate: String,
    hasAdminRole: Boolean,
    nonPeople: Boolean,
    officialVersion: Boolean,
    startDate: String,
    status: Number
  },
  data() {
    return {
      despesasCount: 0,
      batchModal: {
        data: {},
        opened: false
      },
      confirmDeleteModal: {
        alert: "",
        item: null,
        items: [],
        title: ""
      },
      opts: {
        acompanhamentos: [],
        centroCustos: [],
        tipos: [
          {
            id: DespesaTipoEnum.PROJETADO,
            name: "Projetado"
          },
          {
            id: DespesaTipoEnum.REALIZADO,
            name: "Realizado"
          }
        ]
      },
      selection: []
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    actionBarButtons() {
      if (
        !this.hasAdminRole &&
        !this.isInitialPhase &&
        !this.isVersioningMode &&
        this.isExecutionPhase &&
        !this.officialVersion
      ) {
        return [];
      }

      return [
        {
          text: "Adicionar",
          icon: "mdi-plus-box-multiple-outline",
          action: () => {
            this.batchModal.data = {};
            this.batchModal.opened = true;
          }
        }
      ];
    },
    areSelectedTypesMixed() {
      return (
        this.selection.length > 1 &&
        this.selection.some(({ tipo }) => tipo === DespesaTipoEnum.PROJETADO) &&
        this.selection.some(({ tipo }) => tipo === DespesaTipoEnum.REALIZADO)
      );
    },
    batchFields() {
      const today = moment();
      const startDate = moment(this.startDate);
      const hasStarted = today.isSameOrAfter(startDate, "month");
      const hasSelectedTipo = !isNil(this.batchModal.data.tipo);
      const isSelectedTypeReal =
        hasSelectedTipo &&
        this.batchModal.data.tipo === DespesaTipoEnum.REALIZADO;
      const showFirstSubtitle = this.isVersioningMode && !hasSelectedTipo;
      const showSecondSubtitle =
        isSelectedTypeReal && !hasStarted && !this.hasAdminRole;
      const isMonthFieldEditable =
        this.hasAdminRole ||
        this.isInitialPhase ||
        !this.isVersioningMode ||
        (hasSelectedTipo && (!isSelectedTypeReal || hasStarted));

      return [
        {
          key: "nome_gasto",
          name: "Fornecedor",
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }],
          type: this.$fieldTypes.TEXT,
          colSize: 12
        },
        {
          key: "descricao",
          name: "Descrição",
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }],
          type: this.$fieldTypes.TEXT,
          colSize: 12
        },
        {
          key: "firstSubtitle",
          name:
            "Você deve selecionar o Tipo de despesa antes de preencher o intervalo de competências.",
          type: this.$fieldTypes.SUBTITLE,
          colSize: 12,
          hideInform: !showFirstSubtitle
        },
        {
          key: "secondSubtitle",
          name:
            "Atenção: Não é possível cadastro de valores realizados antes do começo da amortização.",
          type: this.$fieldTypes.SUBTITLE,
          colSize: 12,
          hideInform: !showSecondSubtitle
        },
        {
          key: "tipo",
          name: "Tipo",
          type: this.$fieldTypes.SELECT,
          rel: {
            to: "tipos",
            key: "id",
            name: "name"
          },
          rules: [{ rule: "required" }],
          colSize: 4,
          hideInform: !this.isVersioningMode
        },
        {
          key: "competenciaIni",
          name: "Competência inicial",
          type: this.$fieldTypes.MONTH,
          rules: [{ rule: "required" }],
          editable: isMonthFieldEditable,
          maxDate: this.maxPossibleDate,
          minDate: this.minPossibleDate,
          colSize: this.isVersioningMode ? 4 : 6
        },
        {
          key: "competenciaFim",
          name: "Competência final",
          type: this.$fieldTypes.MONTH,
          rules: [{ rule: "required" }],
          editable: isMonthFieldEditable,
          maxDate: this.maxPossibleDate,
          minDate: this.minPossibleDate,
          colSize: this.isVersioningMode ? 4 : 6
        },
        {
          key: "centro_custo_id",
          name: "Centro de Custo",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: {
            to: "centroCustos",
            key: "centro_custo_id",
            name: "centro_custo"
          },
          colSize: 4,
          rules: [{ rule: "required" }]
        },
        {
          key: "acompanhamento",
          name: "Acompanhamento",
          rules: [{ rule: "required" }],
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "acompanhamentos", key: "id", name: "acompanhamento" },
          colSize: 4
        },
        {
          key: "valor",
          name: "Valor Mensal",
          type: this.$fieldTypes.MONEY,
          rules: [
            { rule: "required" },
            { rule: "min", params: { size: 0.01 } }
          ],
          colSize: 4
        },
        {
          key: "vinculacao",
          name:
            "Justificativa para capitalização (motivo pelo qual entende-se que o custo é essencial para etapa de desenvolvimento da incitativa)",
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }],
          type: this.$fieldTypes.TEXTAREA,
          colSize: 12
        }
      ];
    },
    businessPlanId() {
      return this.$route.params.id;
    },
    cols() {
      return [
        {
          key: "nome_gasto",
          name: "Fornecedor",
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }],
          type: this.$fieldTypes.TEXT,
          colSize: 6
        },
        {
          key: "vinculacao",
          name: "Justificativa para capitalização",
          type: this.$fieldTypes.TEXT,
          hideInform: true
        },
        {
          key: "descricao",
          name: "Descrição",
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }],
          type: this.$fieldTypes.TEXT,
          colSize: 6
        },
        {
          key: "acompanhamento",
          name: "Acompanhamento",
          rules: [{ rule: "required" }],
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "acompanhamentos", key: "id", name: "acompanhamento" },
          colSize: 6
        },
        {
          key: "valor",
          name: "Valor Mensal",
          type: this.$fieldTypes.MONEY,
          rules: [{ rule: "required" }],
          colSize: 6
        },
        {
          key: "competencia",
          name: "Competência",
          type: this.$fieldTypes.MONTH,
          rules: [{ rule: "required" }],
          maxDate: this.maxPossibleDate,
          minDate: this.minPossibleDate,
          colSize: !this.isInitialPhase ? 4 : 6
        },
        {
          key: "centro_custo_id",
          name: "Centro de Custo",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: {
            to: "centroCustos",
            key: "centro_custo_id",
            name: "centro_custo"
          },
          colSize: !this.isInitialPhase ? 4 : 6,
          rules: [{ rule: "required" }]
        },
        {
          key: "tipo",
          name: "Tipo",
          type: this.$fieldTypes.SELECT,
          rel: {
            to: "tipos",
            key: "id",
            name: "name"
          },
          colSize: 4
        },
        {
          key: "vinculacao",
          name:
            "Justificativa para capitalização (motivo pelo qual entende-se que o custo é essencial para etapa de desenvolvimento da incitativa)",
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }],
          type: this.$fieldTypes.TEXTAREA,
          hideInTable: true,
          colSize: 12
        }
      ];
    },
    customResource() {
      const url = `/v1/ativacaoped/${this.clientId}/business-plans/${this.businessPlanId}/despesas`;
      const resource = this.apiResource(url);
      const api = this.api();

      return {
        ...resource,
        save(data) {
          if (isNil(data)) {
            return;
          }

          const dispenses = Array.isArray(data) ? data : [data];

          return resource.save(dispenses);
        },
        batchDelete(despesa_ids) {
          return api.delete(url, { data: { despesa_ids } });
        }
      };
    },
    // Todos os status que não os citados abaixo, atualmente apenas Andamento, Pré-amortização e Amortização
    isExecutionPhase() {
      return (
        !this.isInitialPhase &&
        !this.isVersioningMode &&
        this.status !== StatusBusinessPlanEnum.REPROVADO
      );
    },
    isInitialPhase() {
      return [
        StatusBusinessPlanEnum.PREENCHIMENTO,
        StatusBusinessPlanEnum.APROVACAO
      ].includes(this.status);
    },
    isVersioningMode() {
      return [
        StatusBusinessPlanEnum.PREENCHIMENTO_NOVA_VERSAO,
        StatusBusinessPlanEnum.APROVACAO_NOVA_VERSAO
      ].includes(this.status);
    },
    maxPossibleDate() {
      if (
        this.hasAdminRole ||
        this.isInitialPhase ||
        (this.isVersioningMode &&
          this.batchModal.data.tipo === DespesaTipoEnum.PROJETADO)
      ) {
        return this.endDate;
      }

      const today = moment();
      const endDate = moment(this.endDate);
      const target = today.isSameOrBefore(endDate, "month") ? today : endDate;
      return target.format("YYYY-MM");
    },
    minPossibleDate() {
      if (
        this.hasAdminRole ||
        this.isInitialPhase ||
        this.isExecutionPhase ||
        (this.isVersioningMode &&
          this.batchModal.data.tipo === DespesaTipoEnum.REALIZADO)
      ) {
        return this.startDate;
      }

      const today = moment();
      const startDate = moment(this.startDate);
      const target = today.isSameOrAfter(startDate, "month")
        ? today
        : startDate;
      return target.format("YYYY-MM");
    },
    tableClass() {
      if (!this.hasAdminRole && !this.isInitialPhase && !this.officialVersion) {
        return "disabled-hover-pointer";
      }

      return "";
    }
  },
  created() {
    this.getAcompanhamentos();
    this.getCentroCusto();
  },
  methods: {
    contextmenu(row, event, _, col) {
      if (
        !this.hasAdminRole &&
        !this.isInitialPhase &&
        !this.isVersioningMode &&
        (!this.isExecutionPhase || !this.officialVersion)
      ) {
        return;
      }

      const rowDate = row.competencia
        ? moment(row.competencia, "YYYY-MM")
        : moment(0);
      const today = moment();
      const isFromPast = rowDate.isBefore(today, "month");
      const disabledProjetado =
        !this.hasAdminRole &&
        !this.isInitialPhase &&
        (!this.isVersioningMode || isFromPast);
      const disabledRealizado = this.isInitialPhase && !this.hasAdminRole;

      const disableEdit =
        this.selection.length > 1 ||
        (row.tipo === DespesaTipoEnum.REALIZADO
          ? disabledRealizado
          : disabledProjetado);
      // Ter tipos diferentes selecionados habilita o botão de acordo com as regras de Realizado,
      // pois ao clicar no botão as despesas inválidas devem ser removidas da seleção
      // automaticamente.
      const disableDelete =
        this.areSelectedTypesMixed || row.tipo === DespesaTipoEnum.REALIZADO
          ? disabledRealizado
          : disabledProjetado;

      const disableEditTitle =
        this.selection.length > 1
          ? "Não é possível editar Outras Despesas em lote."
          : `Não é possível editar Outras Despesas projetadas ${
              isFromPast ? "do passado" : "sem criar uma nova versão"
            }.`;
      const disableDeleteTitle = `Não é possível excluir Outras Despesas projetadas ${
        isFromPast ? "do passado" : "sem criar uma nova versão"
      }.`;

      const menu = [
        {
          name: "Editar",
          disabled: disableEdit,
          disabledTitle: disableEditTitle,
          cb: async row => {
            this.selection = []; // Limpa itens selecionados pois não tem suporte para edição em lote

            if (!this.$refs.masterDetail) {
              this.$notify({
                group: "geral",
                duration: 5000,
                type: "error",
                title: `Erro no menu de contexto`,
                text: `Atualize a página e tente novamente. Se o problema persistir, envie esse erro para o suporte.`
              });
              return;
            }

            this.$refs.masterDetail.selectedItem = { ...row };
            this.$refs.masterDetail.saveDialog = true;
          }
        },
        {
          name: `Excluir${this.selection.length > 1 ? " em lote" : ""}`,
          disabled: disableDelete,
          disabledTitle: disableDeleteTitle,
          cb: async row => {
            this.confirmDeleteModal.alert = "";

            if (!this.selection.includes(row)) {
              this.selection.push(row);
            }

            if (this.areSelectedTypesMixed) {
              const today = moment();
              const [realizados, projetados] = partition(
                this.selection,
                ({ tipo }) => tipo === DespesaTipoEnum.REALIZADO
              );

              if (!this.hasAdminRole) {
                const [
                  projetadosAtualEFuturo,
                  projetadosPassado
                ] = partition(projetados, ({ competencia }) =>
                  today.isSameOrBefore(moment(competencia, "YYYY-MM"))
                );

                if (this.isVersioningMode) {
                  this.selection = realizados.concat(projetadosAtualEFuturo);
                  this.confirmDeleteModal.alert =
                    projetadosPassado.length > 0
                      ? "Não é possível excluir despesas projetadas passadas. Elas foram removidas da seleção."
                      : "";
                }

                // isExecutionPhase
                this.selection = realizados;
                this.confirmDeleteModal.alert =
                  "Não é possível excluir despesas projetadas sem criar uma nova versão. Elas foram removidas da seleção.";
              }
            }

            this.confirmDeleteModal.title = `Confirmar exclusão de ${
              this.selection.length > 1
                ? `${this.selection.length} registros`
                : "registro"
            }`;
            this.confirmDeleteModal.item =
              this.selection.length === 1 ? this.selection[0] : null;
            this.confirmDeleteModal.items =
              this.selection.length > 1 ? this.selection : [];
            const confirm = await this.$refs.confirmDeleteModal.asyncOpen();

            if (!confirm) {
              return;
            }

            try {
              this.$emit("addLoadingProcess", "batchDeleteOutrasDespesas");
              const ids = this.selection.map(({ id }) => id);
              await this.customResource.batchDelete(ids);
              this.$refs.masterDetail?.doLoad();
              this.selection = [];
              this.$notify({
                group: "geral",
                duration: 5000,
                type: "sucess",
                title: "Registro(s) excluídos com sucesso",
                text: `${ids.length} despesa${
                  ids.length > 1 ? "s foram" : " foi"
                } removida${ids.length > 1 ? "s" : ""} com sucesso.`
              });
            } catch (error) {
              this.notify(error);
            } finally {
              this.$emit("removeLoadingProcess", "batchDeleteOutrasDespesas");
            }
          }
        }
      ];

      this.showContext({
        left: event.clientX,
        top: event.clientY,
        val: row,
        col,
        menu
      });
    },
    async doBatchSave(data, close) {
      try {
        const { competenciaIni, competenciaFim, tipo, ...rest } = data;
        const startDate = moment(competenciaIni, "YYYY-MM");
        const endDate = moment(competenciaFim, "YYYY-MM");
        const diff = endDate.diff(startDate, "months") + 1;
        const defaultTipo =
          !this.isInitialPhase && !this.hasAdminRole
            ? DespesaTipoEnum.REALIZADO
            : DespesaTipoEnum.PROJETADO;
        const parsedData = Array.from({ length: diff }, (_, index) => {
          const competencia = moment(startDate)
            .add(index, "month")
            .format("YYYY-MM");
          return {
            ...rest,
            competencia,
            tipo: tipo ?? defaultTipo
          };
        });

        await this.customResource.save(parsedData);

        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title: "Registro(s) adicionados com sucesso",
          text: `${parsedData.length} despesa${
            parsedData.length > 1 ? "s foram" : " foi"
          } adicionado${parsedData.length > 1 ? "s" : ""} com sucesso.`
        });
        this.$refs.masterDetail?.doLoad();

        if (close) {
          close();
        }

        this.$emit("reload");
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    async getAcompanhamentos() {
      try {
        const { get } = this.apiResource(
          `v1/ativacaoped/${this.clientId}/despesas/selecao`
        );
        this.opts.acompanhamentos = [];
        const response = await get();
        this.opts.acompanhamentos = response.sort(
          ({ acompanhamento: a }, { acompanhamento: b }) => a.localeCompare(b)
        );
      } catch (error) {
        this.notify(error);
        this.opts.acompanhamentos = [];
      }
    },
    async getCentroCusto() {
      try {
        this.opts.centroCustos = [];
        const { get } = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/centros-de-custo/selecao`
        );
        const response = await get();
        this.opts.centroCustos = response.map(cc => {
          return {
            ...cc,
            centro_custo_id: cc.id,
            centro_custo: cc.nome
          };
        });
      } catch {
        this.opts.centroCustos = [];
      }
    },
    onDespesasLoaded(rows) {
      this.despesasCount = rows ? rows.length : 0;
    },
    validate(mode = "save") {
      if (mode === "approve" && this.nonPeople && this.despesasCount === 0) {
        this.$emit("error", 1);
        this.$notify({
          group: "geral",
          type: "error",
          title: "Outras Despesas obrigatórias",
          text: "Business Plan 100% non people deve ter ao menos uma Outra Despesa.",
          duration: 7000
        });
        return false;
      }
      this.$emit("error", 0);
      return true;
    },
    toMonth
  }
};
</script>

<template>
  <div class="table-container">
    <MasterDetail
      ref="masterDetail"
      :actionBarButtons="actionBarButtons"
      :canDelete="false"
      :canEdit="false"
      class="expenses-table"
      :class="tableClass"
      :cols="cols"
      :customResource="customResource"
      disableContextMenu
      formWidth="800"
      :hasExportCSV="false"
      :hasExportXLSX="false"
      :hasFilter="false"
      :hasNewButton="false"
      height="auto"
      :opts="opts"
      :selectionCol="hasAdminRole || !(isExecutionPhase && !officialVersion)"
      :selection.sync="selection"
      @contextmenu="contextmenu"
      @loadedRows="onDespesasLoaded"
    ></MasterDetail>

    <FormModal
      :cols="batchFields"
      :opened.sync="batchModal.opened"
      :opts="opts"
      title="Cadastrar Terceiros/Outras Despesas em lote"
      titleIcon="mdi-plus-box-multiple-outline"
      :value.sync="batchModal.data"
      maxWidth="900"
      @save="doBatchSave"
    />

    <Modal ref="confirmDeleteModal" :title="confirmDeleteModal.title">
      <v-alert v-if="confirmDeleteModal.alert" dense text type="warning">
        {{ confirmDeleteModal.alert }}
      </v-alert>

      <p v-if="confirmDeleteModal.item">
        Deseja excluir <b> {{ confirmDeleteModal.item.nome_gasto }} </b> da
        competência <b> {{ toMonth(confirmDeleteModal.item.competencia) }} </b>?
      </p>
      <p v-else>As seguintes despesas serão excluídas:</p>

      <ul v-if="confirmDeleteModal.items">
        <li v-for="item of confirmDeleteModal.items" :key="item.id">
          <b>{{ item.nome_gasto }}</b> de <b>{{ toMonth(item.competencia) }}</b>
        </li>
      </ul>

      <p>Essa ação não poderá ser desfeita.</p>

      <template #buttons="{ close }">
        <v-spacer />

        <v-btn
          class="px-5 ml-3"
          color="secondary"
          depressed
          @click="close(false)"
        >
          Cancelar
        </v-btn>

        <v-btn class="px-5 ml-3" color="error" depressed @click="close(true)">
          Excluir
        </v-btn>
      </template>
    </Modal>
  </div>
</template>

<style lang="scss" scoped>
.table-container {
  height: 100%;
}

.expenses-table {
  height: 100%;

  &::v-deep .v-card {
    height: 100%;
    display: flex;
    flex-direction: column;

    .v-card__text {
      flex-shrink: 0;
    }

    .v-data-table {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .v-data-table__wrapper {
      flex-grow: 1;
      overflow: auto;
    }

    .v-data-footer {
      flex-shrink: 0;
    }
  }

  &.disabled-hover-pointer::v-deep tr {
    cursor: auto;
  }
}
</style>
